
<div class="relative">

  <app-dynamic-grid
    [gridConfig]="gridConfig"
    [getDataUrl]="getDataUrl"
    [sortBy]="'createdAt'"
    [sortOrder]="'desc'"
    [extraActions]="extraActions"
    (onToggleShowToastEmitter)="showToast($event)"
  ></app-dynamic-grid>

  <app-toast></app-toast>
</div>

<!-- Agent Status Timeline Modal -->
<div *ngIf="showTimelineModal" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-60"
  (click)="closeTimelineModal()">
  <div class="bg-white rounded-lg shadow-2xl w-11/12 max-w-6xl max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 gap-4">
      <h2 class="text-lg font-semibold text-gray-800 flex-shrink-0">Agent Health Status Timeline (Practice-wise)</h2>

      <div class="flex items-center gap-3 ml-auto">

        <!-- Practice Filter Dropdown -->
        <div class="relative" appClickOutsideDirective (appClickOutside)="showPracticeFilterDropdown = false">
          <button type="button"
            class="inline-flex items-center gap-2 px-3 py-1.5 border border-gray-300 bg-white text-sm text-gray-700 hover:bg-gray-50 focus:outline-none rounded"
            (click)="showPracticeFilterDropdown = !showPracticeFilterDropdown; $event.stopPropagation()">
            <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
            </svg>
            <span>Filter Practices</span>
            <span *ngIf="selectedTimelinePractices.size > 0"
              class="inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-indigo-500 rounded-full">
              {{ selectedTimelinePractices.size }}
            </span>
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Dropdown Panel -->
          <div *ngIf="showPracticeFilterDropdown"
            class="absolute left-0 top-full mt-1 w-64 bg-white border border-gray-200 rounded shadow-lg z-50 flex flex-col"
            style="max-height: 320px;">

            <!-- Search -->
            <div class="px-3 pt-3 pb-2 border-b border-gray-100">
              <input type="text" placeholder="Search practice..."
                class="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-400"
                [(ngModel)]="practiceFilterSearch" />
            </div>

            <!-- Options -->
            <div class="overflow-y-auto flex-1" style="max-height: 200px;">
              <div *ngFor="let code of filteredPracticeOptions"
                class="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
                (click)="toggleTimelinePractice(code)">
                <input type="checkbox" class="h-4 w-4 text-indigo-600 rounded"
                  [checked]="selectedTimelinePractices.has(code)"
                  (change)="toggleTimelinePractice(code)" />
                <span class="text-sm text-gray-700 regular-font">{{ code }}</span>
              </div>
              <div *ngIf="filteredPracticeOptions.length === 0"
                class="px-3 py-2 text-sm text-gray-400 regular-font">No practices found</div>
            </div>

            <!-- Actions -->
            <div class="flex justify-between items-center px-3 py-2 border-t border-gray-100 gap-2">
              <button type="button"
                class="text-xs text-gray-500 hover:text-gray-700 regular-font"
                (click)="clearPracticeFilter()">Clear</button>
              <button type="button"
                class="px-3 py-1 text-xs text-white bg-indigo-500 hover:bg-indigo-400 rounded regular-font"
                (click)="applyPracticeFilter()">Apply</button>
            </div>
          </div>
        </div>

        <!-- Close Button -->
        <button (click)="closeTimelineModal()" class="text-gray-400 hover:text-gray-600 focus:outline-none">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="flex-1 overflow-auto px-6 py-4">

      <!-- Loading -->
      <div *ngIf="isTimelineLoading" class="flex items-center justify-center h-48">
        <div class="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-indigo-500"></div>
      </div>

      <!-- Error -->
      <div *ngIf="!isTimelineLoading && timelineError"
        class="flex items-center justify-center h-48 text-red-500 regular-font">
        {{ timelineError }}
      </div>

      <!-- Chart -->
      <div *ngIf="!isTimelineLoading && !timelineError">
        <div class="flex items-center gap-4 mb-3">
          <span class="flex items-center gap-1 regular-font text-sm">
            <span class="inline-block w-3 h-3 rounded-sm bg-green-500"></span> Healthy
          </span>
          <span class="flex items-center gap-1 regular-font text-sm">
            <span class="inline-block w-3 h-3 rounded-sm bg-red-500"></span> Unhealthy
          </span>
          <span *ngIf="selectedTimelinePractices.size > 0" class="text-xs text-indigo-600 regular-font ml-2">
            Showing {{ selectedTimelinePractices.size }} of {{ timelinePracticeOptions.length }} practices
          </span>
        </div>

        <!-- Informational hint when no filter applied -->
        <div *ngIf="selectedTimelinePractices.size === 0"
          class="flex items-center gap-2 px-4 py-3 mb-4 bg-blue-50 border border-blue-200 rounded text-sm text-blue-700 regular-font">
          <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Use the <strong class="mx-1">Filter Practices</strong> button above to select specific practices and view their timeline.
        </div>

        <div id="agent-timeline-chart" class="w-full overflow-x-auto"></div>
      </div>

    </div>
  </div>
</div>
